import React from "react";
import { X, Eye, FilePdf, FileDoc } from "@phosphor-icons/react";
import { resolveMedia } from "@/lib/api";

const OFFICE_EMBED = "https://view.officeapps.live.com/op/embed.aspx?src=";

// Read-only document viewer for players: no download, no edit.
export const DocumentViewer = ({ doc, onClose }) => {
  if (!doc) return null;
  const url = resolveMedia(doc.url);
  const ct = (doc.content_type || "").toLowerCase();
  const lower = url.toLowerCase();
  const isPdf = ct.includes("pdf") || lower.includes(".pdf");
  const isImage = ct.startsWith("image");
  const isDoc = ct.includes("word") || ct.includes("msword") || /\.docx?(\?|$)/.test(lower);
  const noCtx = (e) => e.preventDefault();

  return (
    <div className="fixed inset-0 z-[60] flex flex-col bg-black/90 backdrop-blur-sm" data-testid="doc-viewer" onContextMenu={noCtx}>
      <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-b border-white/10 bg-[#121212]">
        <div className="flex items-center gap-2 min-w-0">
          {isPdf ? <FilePdf size={20} className="text-[#FF5722]" /> : isDoc ? <FileDoc size={20} className="text-[#FF5722]" /> : <Eye size={20} className="text-[#FF5722]" />}
          <span className="font-semibold truncate">{doc.name || "Document"}</span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-wide bg-white/10 text-white/50 px-2 py-0.5 ml-2">View only</span>
        </div>
        <button onClick={onClose} data-testid="doc-viewer-close" className="text-white/60 hover:text-white shrink-0"><X size={24} /></button>
      </div>

      <div className="flex-1 overflow-hidden bg-[#0A0A0A] relative" onContextMenu={noCtx}>
        {isImage ? (
          <div className="w-full h-full flex items-center justify-center p-4 overflow-auto">
            <img src={url} alt={doc.name || ""} draggable={false} onContextMenu={noCtx}
              className="max-w-full max-h-full object-contain select-none pointer-events-none" data-testid="doc-viewer-image" />
          </div>
        ) : isPdf ? (
          <iframe title={doc.name || "PDF"} src={`${url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            className="w-full h-full border-0" data-testid="doc-viewer-pdf" />
        ) : isDoc ? (
          <iframe title={doc.name || "Document"} src={`${OFFICE_EMBED}${encodeURIComponent(url)}`}
            className="w-full h-full border-0 bg-white" data-testid="doc-viewer-doc" />
        ) : (
          <iframe title={doc.name || "File"} src={url} className="w-full h-full border-0" data-testid="doc-viewer-generic" />
        )}
      </div>

      <div className="px-4 py-2 text-center text-[11px] text-white/35 bg-[#121212] border-t border-white/10">
        Read-only preview · downloading and editing are disabled
      </div>
    </div>
  );
};
